const cleanData = (values) => {
  let filterArray = ["_", "__typename"];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });
  if (!values["files"]) {
    values["files"] = [];
  }

  // used when updating the form to flatten into "files"
  if (
    values["jobDutiesFiles"] &&
    typeof values["jobDutiesFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(values["jobDutiesFiles"]);
    values["jobDutiesFiles"] = "YES";
  }
  if (
    values["coveredByAcwiaFiles"] &&
    typeof values["coveredByAcwiaFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(values["coveredByAcwiaFiles"]);
    values["coveredByAcwiaFiles"] = "YES";
  }
  if (
    values["sportsLeagueOrganizationFiles"] &&
    typeof values["sportsLeagueOrganizationFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["sportsLeagueOrganizationFiles"]
    );
    values["sportsLeagueOrganizationFiles"] = "YES";
  }
  if (
    values["sportsLeagueLetterFiles"] &&
    typeof values["sportsLeagueLetterFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(values["sportsLeagueLetterFiles"]);
    values["sportsLeagueLetterFiles"] = "YES";
  }
  if (
    values["sportsLeagueUnionFiles"] &&
    typeof values["sportsLeagueUnionFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(values["sportsLeagueUnionFiles"]);
    values["sportsLeagueUnionFiles"] = "YES";
  }

  if (values["cbaFiles"] && typeof values["cbaFiles"] === "object") {
    values["files"] = values["files"].concat(values["cbaFiles"]);
    values["cbaFiles"] = "YES";
  }
  if (
    values["cbaEmployerLetterFiles"] &&
    typeof values["cbaEmployerLetterFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(values["cbaEmployerLetterFiles"]);
    values["cbaEmployerLetterFiles"] = "YES";
  }
  if (
    values["cbaUnionLetterFiles"] &&
    typeof values["cbaUnionLetterFiles"] === "object"
  ) {
    values["files"] = values["files"].concat(values["cbaUnionLetterFiles"]);
    values["cbaUnionLetterFiles"] = "YES";
  }

  if (values["surveyFiles"] && typeof values["surveyFiles"] === "object") {
    values["files"] = values["files"].concat(values["surveyFiles"]);
    values["surveyFiles"] = "YES";
  }
  if (
    values["surveyFormEta9165Files"] &&
    typeof values["surveyFormEta9165Files"] === "object"
  ) {
    values["files"] = values["files"].concat(values["surveyFormEta9165Files"]);
    values["surveyFormEta9165Files"] = "YES";
  }

  // another cleaner?
  if (values["files"]) {
    values["files"].filter((file) => file.machine_name === "jobDutiesFiles")
      .length > 0
      ? (data["jobDutiesFiles"] = "YES")
      : (data["jobDutiesFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "coveredByAcwiaFiles"
    ).length > 0
      ? (data["coveredByAcwiaFiles"] = "YES")
      : (data["coveredByAcwiaFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "sportsLeagueOrganizationFiles"
    ).length > 0
      ? (data["sportsLeagueOrganizationFiles"] = "YES")
      : (data["sportsLeagueOrganizationFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "sportsLeagueLetterFiles"
    ).length > 0
      ? (data["sportsLeagueLetterFiles"] = "YES")
      : (data["sportsLeagueLetterFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "sportsLeagueUnionFiles"
    ).length > 0
      ? (data["sportsLeagueUnionFiles"] = "YES")
      : (data["sportsLeagueUnionFiles"] = "NO");

    values["files"].filter((file) => file.machine_name === "cbaFiles").length >
    0
      ? (data["cbaFiles"] = "YES")
      : (data["cbaFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "cbaEmployerLetterFiles"
    ).length > 0
      ? (data["cbaEmployerLetterFiles"] = "YES")
      : (data["cbaEmployerLetterFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "cbaUnionLetterFiles"
    ).length > 0
      ? (data["cbaUnionLetterFiles"] = "YES")
      : (data["cbaUnionLetterFiles"] = "NO");

    values["files"].filter((file) => file.machine_name === "surveyFiles")
      .length > 0
      ? (data["surveyFiles"] = "YES")
      : (data["surveyFiles"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "surveyFormEta9165Files"
    ).length > 0
      ? (data["surveyFormEta9165Files"] = "YES")
      : (data["surveyFormEta9165Files"] = "NO");

    if (values["files"].length > 0) {
      for (let j = 0; j < values["files"].length; j++) {
        data["files"][j].size = data["files"][j].size.toString();

        delete data["files"][j].fileTypes;
        data["files"][j].lastModified =
          data["files"][j].lastModified.toString();

        delete data["files"][j].fileUploadedFrom;
        if (data["files"][j].__typename) {
          delete data["files"][j].__typename;
        }
      }
    }
  }
  return data;
};

export { cleanData };
